import { AxiosResponse } from "axios"
import $api from "../../../axios"
import {
  IGetSbCampaignsBody,
  IResultSbCampaigns,
  IUpdateCampaignParams,
  IUpdateCampaignResult,
} from "../types/sbCampaignApi.types"

class SbCampaignApi {
  url: string

  constructor() {
    this.url = "/SB/campaign"
  }

  async getSbCampaigns(data: IGetSbCampaignsBody): Promise<AxiosResponse<IResultSbCampaigns>> {
    return $api.post(`${this.url}/getSBCampaign`, data)
  }

  async updateCampaignsState(
    data: IUpdateCampaignParams
  ): Promise<AxiosResponse<IUpdateCampaignResult[]>> {
    return $api.put(`${this.url}/updateCampaignsState`, data)
  }
}

export default new SbCampaignApi()
